import { useQuery } from '@tanstack/react-query';
import HttpClient from '@/api/HttpClient';

const httpClient = new HttpClient();

export interface TomVendingDashboardRange {
  dateFrom: string;
  dateTo: string;
  days: number;
}

export interface TomVendingDashboardSummary {
  totalUnitsOnHand: number;
  skusWithStock: number;
  catalogItemCount: number;
  activeLocations: number;
  activeMachines: number;
  siteVisitsInRange: number;
  movementCountInRange: number;
  rejectedUnitsInRange: number;
}

export interface TomVendingDashboardMovementsByDayRow {
  date: string;
  fill: number;
  recycle: number;
  reject: number;
  adjustment: number;
  par: number;
  other: number;
  total: number;
}

export interface TomVendingDashboardSiteVisitsByDayRow {
  date: string;
  count: number;
}

export interface TomVendingDashboardInventoryByLocationRow {
  locationId: number;
  locationName: string;
  totalUnits: number;
  isWarehouse: boolean;
}

export interface TomVendingDashboardMovementsByReasonRow {
  reason: string;
  movementCount: number;
  totalQuantity: number;
}

export interface TomVendingDashboardPayload {
  range: TomVendingDashboardRange;
  summary: TomVendingDashboardSummary;
  movementsByDay: TomVendingDashboardMovementsByDayRow[];
  siteVisitsByDay: TomVendingDashboardSiteVisitsByDayRow[];
  inventoryByLocation: TomVendingDashboardInventoryByLocationRow[];
  movementsByReason: TomVendingDashboardMovementsByReasonRow[];
}

export async function fetchTomVendingDashboard(days = 30): Promise<TomVendingDashboardPayload> {
  const response = await httpClient.post('api/tom-vending/dashboard', { days });
  return response.data as TomVendingDashboardPayload;
}

export function useTomVendingDashboard(days = 30) {
  return useQuery({
    queryKey: ['tom-vending-dashboard', days],
    queryFn: () => fetchTomVendingDashboard(days),
    staleTime: 60_000,
  });
}
